import React from 'react';
import clsx from 'clsx';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Card, CardContent } from '@mui/material';
import { Page, FilesDropzone, Header } from 'components';
import { enqueueSnackbar } from 'actions';

import { Upload } from '../../actions/UploadsActions.js';
import { SiteString } from './components';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
	tabs: {
		marginTop: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(3),
	},
}));

const Uploads = () => {
	const classes = useStyles();
	const dispatch = useDispatch();

	const _upload = (file) => {
		if (file[0].size > 200000000) {
			dispatch(enqueueSnackbar({ message: 'File size cannot be superior to 200MB', options: { variant: 'warning' } }));
			return;
		}

		dispatch(Upload(file[0]));
	};

	return (
		<Page className={classes.root} title="Uploads">
			<Header module="Kpis" view="Reports" />
			<div className={clsx(classes.container)}>
				<SiteString />
				<Card className={classes.container}>
					<CardContent>
						<FilesDropzone multiple={false} acceptedTypes=".zip" upload={_upload} />
					</CardContent>
				</Card>
			</div>
		</Page>
	);
};

export default Uploads;
